<div class="toast-body">
  <y42-icon class="toast-type-icon" [icon]="icon"></y42-icon>
  <div class="toast-body-message">
    <span class="font-normal">{{ toastTitle }}</span>
    <span *ngIf="toastDescription" class="toast-description">{{ toastDescription }}</span>
  </div>
  <button mat-icon-button class="toast-close custom-button-icon-big" (click)="close()">
    <y42-icon [icon]="'close'"></y42-icon>
  </button>
</div>

<div class="toast-actions">
  <button mat-flat-button *ngFor="let action of actions; trackBy: trackByID" (click)="close(action.id)">
    {{ action.label }}
  </button>
</div>
